import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class ChatUser extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    active: PropTypes.bool,
  };

  static defaultProps = {
    active: false,
  };

  render() {
    const { contact, active, t} = this.props;
    let lastMessage = '';
    if (contact.messages.length) {
      lastMessage = contact.messages.slice(-1)[0].message;
    } else {
      lastMessage = t('chats.newContact');
    }
    const contactClass = classNames({
      chat__contact: true,
      'chat__contact--active': active,
    });

    let alertNew = '';
    if(contact.newMessages){
      alertNew = <div className="topbar__btn topbar__btn--new">
                  <div className="topbar__btn-new-label"><div /></div>
                </div>
    }

    return (
      <div className={contactClass}>
        <div className="chat__contact-avatar">
          <img src={contact.avatar} alt="ava" />
        </div>
        {alertNew}
        <div className="chat__contact-preview">
          <p className="chat__contact-name">{contact.name}</p>
          <p className="chat__contact-post">{contact.post}</p>
          <p className="chat__contact-last-message">{lastMessage}</p>
        </div>
      </div>
    );
  }
}
export default withTranslation('common')(ChatUser);